import PopupRegistration from './PopupRegistration';

export default PopupRegistration;
